/**
 * CL-DESIGN-BOARDS-DB-1B — Design Boards capability keys (dependency-free).
 */

export const DESIGN_BOARD_PERMISSION_KEYS = Object.freeze({
  view: "canViewDesignBoards",
  manage: "canManageDesignBoards",
  contribute: "canContributeDesignBoardItems",
  comment: "canCommentOnDesignBoards",
});

export const DESIGN_BOARD_PERMISSION_KEY_LIST = Object.freeze(
  Object.values(DESIGN_BOARD_PERMISSION_KEYS)
);

export function isDesignBoardPermissionKey(key = "") {
  return DESIGN_BOARD_PERMISSION_KEY_LIST.includes(String(key ?? "").trim());
}
